import TsaDigitalCertificateAgreement from '@/components/digitalCertificateAgreement/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const DigitalCertificateAgreement = vue.extend(TsaDigitalCertificateAgreement)
    if (!$vm) {
      $vm = new DigitalCertificateAgreement({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const digitalCertificateAgreement = {
      show (options = {}) {
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
        $vm.init()
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaDigitalCertificateAgreement) {
      vue.prototype.$TsaDigitalCertificateAgreement = digitalCertificateAgreement
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/digitalCertificateAgreement/index.js